import type { ReactNode } from 'react';

export const symbol_reset_tv: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-120q-12.75 0-21.37-8.63Q330-137.25 330-150v-50H140q-24.75 0-42.37-17.63Q80-235.25 80-260v-520q0-24.75 17.63-42.38Q115.25-840 140-840h680q24.75 0 42.38 17.62Q880-804.75 880-780v137q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-137H140v520h680v-233H487l69 68q9 9 9 21t-9 21q-9 9-21 9t-21-9L394-502q-9-9-9-21t9-21l120-120q9-9 21-9t21 9q9 9 9 21t-9 21l-69 69h333q23 0 41.5 18.5T880-493v233q0 24.75-17.62 42.37Q844.75-200 820-200H630v50q0 12.75-8.62 21.37Q612.75-120 600-120H360Zm150-403Z"
		/>
	</svg>
);
